const mutation = {
  initialReset(state) {
    state.list = [];
    state.rejectedlist = [];
    state.rejectionFilter = {};
    state.rejectionFilter.page = 1;
    state.rejectionFilter.page_limit = 25;
    state.filter = {};
    state.filter.page = 1;
    state.hasEmpty = true;
    state.isLoading = false;
    state.invoiceDetails = [];
  },

  paginationCheck(state, status) {
    state.isPaginating = status;
  },

  SET_LOADING(state, status) {
    state.isLoading = status;
  },

  SET_TRANSPORTER_LOADING(state, status) {
    state.isTransporterLoading = status;
  },

  SET_LIST(state, data) {
    const result = (state.filter.page > 1) ? state.list.concat(data) : data;
    state.list = result;
    if (data.length) {
      state.filter.page += 1;
      state.hasEmpty = false;
    } else {
      state.hasEmpty = true;
    }
  },

  SET_REJECTED_LIST(state, data) {
    let result = {};
    if (state.rejectionFilter.page > 1) {
      const trips = state.rejectedlist.trips;
      result.trips = trips.concat(data.trips);
    } else {
      result = data;
    }
    state.rejectedlist = result;
    if (data.trips && data.trips.length) {
      state.rejectionFilter.page += 1;
      state.hasEmpty = false;
    } else {
      state.hasEmpty = true;
    }
  },
  setPage(state, page) {
    state.filter.page = page;
  },

  setRejectionPage(state, page) {
    state.rejectionFilter.page = page;
  },

  setHasEmpty(state, data) {
    state.hasEmpty = data;
  },
};

export default mutation;
